import cx from "classnames";
import * as React from "react";

interface QESWidgetTitleProps {
  className?: string;
}

/**
 * Renders text in bold and slightly bigger to stand out. Meant to be used in the Header
 */
export const QESWidgetTitle: React.FC<React.PropsWithChildren<QESWidgetTitleProps>> = ({
  children,
  className,
}) => {
  return (
    <h3 className={cx("qes-widget__title", className)}>
      {children}
    </h3>
  );
};
